import { cn } from '@/utils/utils_client';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';

interface Props extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Label> {
  inset?: boolean;
}

export const UI_PRIMITIVE__dropdown_menu_label = forwardRef<React.ElementRef<typeof DropdownMenuPrimitive.Label>, Props>(
  ({ className, inset, ...props }, ref) => {
    /*
     * EVENTS
     */

    /*
     * RENDERS
     */

    function render_children() {
      if (props.children) return props.children;
    }

    /*
     * HTML
     */

    return (
      <DropdownMenuPrimitive.Label ref={ref} className={cn('px-2 py-1.5 text-sm font-semibold', inset && 'pl-8', className)} {...props}>
        {render_children()}
      </DropdownMenuPrimitive.Label>
    );
  },
);
UI_PRIMITIVE__dropdown_menu_label.displayName = DropdownMenuPrimitive.Label.displayName;
